import MainButton from "@components/common/Button";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import type { useAppForm } from "@/components/Forms";
import { AlbInput } from "@/components/Forms/albInput";

type Props = {
  form: ReturnType<typeof useAppForm>;
  identifier: string;
  onNextClick?: boolean;
};

export const AuthenticateCode: FunctionComponent<Props> = ({ form, identifier, onNextClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <form.AppField name={identifier}>
        {() => (
          <AlbInput
            label={t("common.form.input.authentication-code")}
            type="TextField"
            variant="filled"
          />
        )}
      </form.AppField>

      {onNextClick && (
        <form.Subscribe selector={(s) => s.values[identifier]}>
          {(value) => (
            <div>
              <MainButton disabled={!value} type="submit">
                {t("common.navigation.next")}
              </MainButton>
            </div>
          )}
        </form.Subscribe>
      )}
    </>
  );
};
